import { Extension } from "@tiptap/core";

export interface TableCellBackgroundOptions {
  HTMLAttributes: Record<string, unknown>;
  types?: unknown;
}

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    tableCellBackground: {
      setTableCellBackground: (color: string) => ReturnType;
      unsetTableCellBackground: () => ReturnType;
    };
  }
}

export const TableCellBackground = Extension.create<TableCellBackgroundOptions>({
  name: "tableCellBackground",
  addOptions() {
    return {
      types: ["tableCell"],
      HTMLAttributes: {},
    };
  },
  // @ts-expect-error
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          backgroundColor: {
            parseHTML: (element) => {
              return element.style.backgroundColor || "";
            },
            renderHTML: (attributes) => {
              if (!attributes.backgroundColor || attributes.backgroundColor === "") {
                return {};
              }

              return {
                style: `background-color: ${attributes.backgroundColor}`,
              };
            },
          },
        },
      },
    ];
  },
});
